import PropTypes from 'prop-types';
import React, { useCallback, useContext, useMemo } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import Switch from 'react-switch';
import css from 'styled-jsx/css';

import BrandingContext from '../../Context/BrandingContext';
import CurrentOrgContext from '../../Context/CurrentOrgContext';

import SearchByOrgDropdown from './SearchByOrgDropdown';
import StatusSelectDropdown from './StatusSelectDropdown';
import SearchByNameDropdown from './SearchByNameDropdown';

const { className, styles } = css.resolve`
  .modal-dialog {
    margin-top: 75px;
  }
`;

export default function MobileFiltersModal(props) {
  const {
    asset,
    assetView,
    handleAssetSelected,
    handleEcosystemToggle,
    handleOrgSelected,
    handleRuleSelected,
    handleStatusSelected,
    includeChildren,
    isOpen,
    orgIdFilter,
    selectedStatus,
    tab,
    toggleModal,
  } = props;
  const currentOrg = useContext(CurrentOrgContext) || {},
    { primary_alert } = useContext(BrandingContext);

  const handleToggle = useCallback(() => {
      handleEcosystemToggle(true);
    }, [handleEcosystemToggle]),
    orgID = useMemo(
      () => (assetView ? asset?.orgID : orgIdFilter || currentOrg?._id),
      [assetView, asset?.orgID, currentOrg?._id, orgIdFilter]
    );

  return (
    <Modal
      isOpen={isOpen}
      className={className}
      backdropClassName="bg-transparent"
      toggle={() => toggleModal(!isOpen)}
    >
      <ModalBody>
        <div className="text-muted mb-3">Filters</div>
        <div className="mb-3">
          <div className="font-weight-lighter nine-tenth-text text-muted">
            Status
          </div>
          <StatusSelectDropdown
            selectedStatus={selectedStatus}
            handleStatusSelected={handleStatusSelected}
            mobileView
          />
        </div>
        <div className={assetView ? 'd-none' : 'mb-3'}>
          <div className="font-weight-lighter nine-tenth-text text-muted">
            Asset
          </div>
          <SearchByNameDropdown
            orgID={orgID}
            resource="Asset"
            handleAssetSelected={handleAssetSelected}
            mobileView
          />
        </div>
        <div className={tab === 'dm1' ? 'd-none' : ''}>
          <div className="font-weight-lighter nine-tenth-text text-muted">
            Rule
          </div>
          <SearchByNameDropdown
            orgID={orgID}
            resource="Rule"
            handleRuleSelected={handleRuleSelected}
            mobileView
          />
        </div>
        <div className={assetView ? 'd-none' : 'mt-3'}>
          <div className="font-weight-lighter nine-tenth-text text-muted">
            Organization
          </div>
          <SearchByOrgDropdown
            handleEcosystemToggle={handleEcosystemToggle}
            handleOrgSelected={handleOrgSelected}
            includeChildren={includeChildren}
            mobileView
            orgID={orgID}
            orgIdFilter={orgIdFilter}
          />
        </div>
        <div
          className={assetView ? 'd-none' : 'mt-2 d-flex align-items-center'}
        >
          <Switch
            checked={includeChildren ?? false}
            checkedIcon={false}
            height={15}
            id="ecosystem-toggle"
            onChange={handleToggle}
            onColor={primary_alert}
            uncheckedIcon={false}
            width={30}
          />
          <p className="mb-0 ml-2 three-quarter-text modal-inputlabel-text">
            Show Ecosystem Events
          </p>
        </div>
      </ModalBody>
      {styles}
    </Modal>
  );
}

MobileFiltersModal.propTypes = {
  asset: PropTypes.object,
  assetView: PropTypes.bool,
  handleAssetSelected: PropTypes.func,
  handleEcosystemToggle: PropTypes.func,
  handleOrgSelected: PropTypes.func,
  handleRuleSelected: PropTypes.func,
  handleStatusSelected: PropTypes.func,
  includeChildren: PropTypes.bool,
  isOpen: PropTypes.bool,
  orgIdFilter: PropTypes.string,
  selectedStatus: PropTypes.oneOf(['all', 'positive', 'negative']),
  tab: PropTypes.oneOf(['alerts', 'dm1']),
  toggleModal: PropTypes.func,
};

MobileFiltersModal.defaultProps = { asset: {}, currentOrg: {} };
